import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";

var _dec, _dec2, _dec3, _class, _class2;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { GetReady, Initialize, Inject, Injectable, Required } from '../decorators';
import { UniFlow } from './UniFlow';

/**
 * 解绑邮箱
 * @link https://shopline.yuque.com/sczv0i/zbwfmf/yphlcyeoguxtes3g
 */
export var UnbindEmailFlow = (_dec = Injectable({
  servcode: 'data.servcode'
}), _dec2 = Inject(['oauthToken']), _dec3 = Required(['_stoken']), (_class = (_class2 = /*#__PURE__*/function (_UniFlow) {
  _inherits(UnbindEmailFlow, _UniFlow);

  var _super = _createSuper(UnbindEmailFlow);

  function UnbindEmailFlow() {
    _classCallCheck(this, UnbindEmailFlow);

    return _super.apply(this, arguments);
  }

  _createClass(UnbindEmailFlow, [{
    key: "init",
    value:
    /** 初始化 */
    function init(params) {
      return this.request('/aq/email/unbind/init.do', params);
    }
    /**
     * 下发邮箱验证码
     * @param params
     */

  }, {
    key: "sendEmailCode",
    value: function () {
      var _sendEmailCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _get(_getPrototypeOf(UnbindEmailFlow.prototype), "sendEmailCode", this).call(this, params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendEmailCode(_x) {
        return _sendEmailCode.apply(this, arguments);
      }

      return sendEmailCode;
    }()
    /** 解绑邮箱 */

  }, {
    key: "unbind",
    value: function () {
      var _unbind = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.request('/aq/email/unbind/unbind.do', params));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unbind(_x2) {
        return _unbind.apply(this, arguments);
      }

      return unbind;
    }()
  }]);

  return UnbindEmailFlow;
}(UniFlow), _defineProperty(_class2, "flowName", 'UnbindEmailFlow'), _class2), (_applyDecoratedDescriptor(_class.prototype, "init", [Initialize, _dec], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendEmailCode", [GetReady], Object.getOwnPropertyDescriptor(_class.prototype, "sendEmailCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unbind", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class.prototype, "unbind"), _class.prototype)), _class));